import { Component, inject, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from 'src/app/services/auth.service'
import {RoundProgressComponent} from 'angular-svg-round-progressbar'

@Component({
  selector: 'app-maintenance',
  imports: [
    RoundProgressComponent
  ],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent implements OnInit {
  // This component is used to show a maintenance page when the application is in maintenance mode.
  // It will be displayed when the backend service returns a "closed" response.
  // The component does not have any specific logic or functionality.
  // It simply displays the maintenance page.

  private authService = inject(AuthService)
  private router = inject(Router)

  public progress = 0

  ngOnInit() {

    let checkRunning = false

    const progressTimer = setInterval(() => {
      if (this.progress >= 150) {
        this.progress = 0
      } else {
        this.progress += 1
      }
    }, 100)


    const intervalTimer = setInterval(() => {
      if (checkRunning) {
        return
      }
      checkRunning = true
      this.authService.validateTokenCookie().subscribe((response: any) => {
        checkRunning = false
        if (response?.closed === false) {
          clearInterval(intervalTimer)
          clearInterval(progressTimer)
          window.location.replace('/home?_cb=' + Math.random()) // Specify the URL to redirect to
        }
      })
    }
    , 15000)
  }

}
